// extracted by mini-css-extract-plugin
module.exports = {"container":"CallUsSection_container__tJfIh","linkWrapper":"CallUsSection_linkWrapper__D6Kzh","imageWrapper":"CallUsSection_imageWrapper__anoE_"};